import { Menu, Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { AppSearchTrigger } from "@/components/app-search-trigger";
import { HeaderUser } from "@/components/header-user";
import Logo from "@/components/logo";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";

type AppHeaderProps = {
  user: {
    name: string;
    planName?: string | null;
    avatar?: string;
    initials: string;
  };
  showUpgradeButton?: boolean;
  showSubscriptionLink?: boolean;
};

export function AppHeader({
  user,
  showUpgradeButton = false,
  showSubscriptionLink = false,
}: AppHeaderProps) {
  const { toggleSidebar } = useSidebar();

  return (
    <header className="sticky top-0 z-50 flex h-14 shrink-0 items-center border-b border-border/60 bg-background">
      <div className="flex w-full items-center gap-3 px-4 md:px-6 lg:px-6">
        <Button
          variant="ghost"
          size="icon"
          className="shrink-0 h-8 w-8 md:hidden"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          <Menu className="size-5" />
        </Button>

        <Link
          to="/dashboard"
          aria-label="OS04 home"
          className="shrink-0 rounded-sm outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/45"
        >
          <Logo className="h-10" />
        </Link>

        <div className="flex flex-1 justify-center">
          <AppSearchTrigger />
        </div>

        <div className="flex shrink-0 items-center gap-2">
          {showUpgradeButton ? (
            <Button
              asChild
              size="sm"
              className="h-8 rounded-full font-semibold"
            >
              <Link to="/billing">
                <span className="flex items-center gap-2 px-2">
                  <Zap className="h-3.5 w-3.5" />
                  Upgrade
                </span>
              </Link>
            </Button>
          ) : null}
          <HeaderUser user={user} showSubscriptionLink={showSubscriptionLink} />
        </div>
      </div>
    </header>
  );
}
